import React, { useEffect, useRef, useState } from "react";

//import Scss
import "react-quill/dist/quill.snow.css";
import "./assets/scss/themes.scss";

//imoprt Route
import Route from "./Routes";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper";

// Fake Backend
// import fakeBackend from "./helpers/AuthType/fakeBackend";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FirebaseCloudMessagingService } from "./FirebaseCloudMessagingService";
import { messaging } from "helpers/firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "Components/Hooks/hooks";
import { getUserDetails } from "slices/thunks";
import { fetchFirebaseConfig } from "slices/config/thunk";
import { onAuthEvent } from "Components/Auth/authEvents";
import FullScreenLoader from "Components/Common/FullScreenLoader";
// import { ErrorToast } from "utils/toast";
// Activating fake backend
// fakeBackend();

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// };

// // init firebase backend
// initFirebaseBackend(firebaseConfig);

function App() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const hasCalledUserDetails = useRef(false);
  const [authRedirecting, setAuthRedirecting] = useState(false);
  const isUnauthorizedRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = onAuthEvent("UNAUTHORIZED", () => {
      // Prevent multiple unauthorized handling
      if (isUnauthorizedRef.current) return;
      isUnauthorizedRef.current = true;

      setAuthRedirecting(true);
      // Clear user state immediately to prevent further API calls
      dispatch({ type: "RESET_APP_STATE" });

      // Add a delay to show the loader before redirecting
      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 1500);
    });

    return unsubscribe;
  }, [dispatch, navigate]);

  useEffect(() => {
    if (location.pathname === "/login") {
      setAuthRedirecting(false);
      isUnauthorizedRef.current = false;
    }
  }, [location.pathname]);

  useEffect(() => {
    dispatch(fetchFirebaseConfig());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    //@ts-ignore
    new FirebaseCloudMessagingService(messaging, navigate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user && user.access_token && !hasCalledUserDetails.current) {
      dispatch(getUserDetails());
      hasCalledUserDetails.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user]);

  return (
    <React.Fragment>
      <FullScreenLoader
        isLoading={authRedirecting}
        message="Redirecting to login..."
      />
      <Route />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </React.Fragment>
  );
}

export default App;
